<div class="main-content">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container-fluid">
            <a class="navbar-brand" [routerLink]="['/home']">
                <img src="assets/img1.png" alt="" width="30" height="24" class="d-inline-block align-text-top">
                toDoList</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarScroll"
                aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse main" id="navbarScroll">
                <ul class=" navbar-nav mt-2  ml-auto" style="--bs-scroll-height: 100px;">
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/login']">Login</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/signup']">Sign up</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    <div class="container">
        <div class="form-content">
            <form [formGroup]="profileLoginForm" (ngSubmit)="loginFunction(profileLoginForm)">
                <div class="form-heading">
                    Login
                </div>
                <div class="form-group">
                    <label for="mailInput">Email</label>
                    <input type="text" class="form-control" [ngClass]="{
                        'has-danger': ((profileLoginForm.get('userLoginMail').invalid && profileLoginForm.get('userLoginMail').dirty)||(profileLoginForm.get('userLoginMail').touched && profileLoginForm.get('userLoginMail').pristine)), 
                        'has-success': profileLoginForm.get('userLoginMail').valid && profileLoginForm.get('userLoginMail').dirty
                      }" id="mailInput" placeholder="Enter your mail Id" formControlName="userLoginMail"
                        data-toggle="tooltip" title="Required">
                </div>
                <div class="form-group">
                    <label for="passwordInput">Password</label>
                    <input type="password" class="form-control" [ngClass]="{
                        'has-danger': ((profileLoginForm.get('userLoginPassword').invalid && profileLoginForm.get('userLoginPassword').dirty)||(profileLoginForm.get('userLoginPassword').touched && profileLoginForm.get('userLoginPassword').pristine)), 
                        'has-success': profileLoginForm.get('userLoginPassword').valid && profileLoginForm.get('userLoginPassword').dirty
                      }" id="passwordInput" placeholder="Enter your password" formControlName="userLoginPassword">
                </div>
                <div class="button-group">
                    <button type="submit" class="btn btn-success d-grid gap-2 col-sm-5"
                        [disabled]="!profileLoginForm.valid">Submit</button>
                    <button type="button" class="btn btn-danger d-grid gap-2 col-sm-5 ml-auto"
                        [disabled]="!profileLoginForm.get('userLoginMail').valid"
                        (click)="sendRecoveryMail(); $event.preventDefault()">Forgot
                        Password?</button>
                </div>
            </form>
        </div>
    </div>
</div>